import { render, staticRenderFns } from "./LabelDetail.vue?vue&type=template&id=0c883957&"
import script from "./LabelDetail.vue?vue&type=script&lang=js&"
export * from "./LabelDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports